import { render } from "./VInputSelect.vue?vue&type=template&id=a1f57728&scoped=true"
import script from "./VInputSelect.vue?vue&type=script&lang=js"
export * from "./VInputSelect.vue?vue&type=script&lang=js"

import "./VInputSelect.vue?vue&type=style&index=0&id=a1f57728&scoped=true&lang=css"

import exportComponent from "F:\\.openserver\\OpenServer\\domains\\geo_exams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1f57728"]])

export default __exports__